import { GENERAL_ERROR_MSG } from "../../contant";
import { apiHandler } from "../../utiles";
import { VALIDATE_CLIENT_ENDPOINT } from "./endpoints";
import {
  VALIDATE_CLIENT_ERROR_CODES,
  VALIDATE_CLIENT_SUCCESS_CODE,
} from "./statusCodes";
import { VALIDATE_CLIENT_ERROR_MESSAGE } from "./errorMessages";

async function validateClientAPI(
  callbackUrl,
  handleValidResponse,
  handleError
) {
  const apiResponse = await apiHandler({
    method: "POST",
    url: `${process.env.REACT_APP_API_BASE_URL}${VALIDATE_CLIENT_ENDPOINT}`,
    reqBody: {
      clientRedirectUrl: callbackUrl,
    },
  });

  if (
    apiResponse?.status === VALIDATE_CLIENT_SUCCESS_CODE &&
    apiResponse?.data?.isValidClient
  ) {
    handleValidResponse();
  } else if (
    VALIDATE_CLIENT_ERROR_CODES.includes(apiResponse?.response?.status)
  ) {
    const errorMessage = VALIDATE_CLIENT_ERROR_MESSAGE;
    handleError(errorMessage);
  } else {
    handleError(GENERAL_ERROR_MSG);
  }
}
export default validateClientAPI;
